import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { marketing } from 'config/global';
import imgWebapp from 'assets/images/v3-hero-webapp.png';
import { PlatformRow } from './components/PlatformRow';
import { StoreBadge } from './components/StoreBadge';

const MacGlyph = () => (
  <svg viewBox="0 0 24 24">
    <rect x="3" y="4" width="18" height="12" rx="2" />
    <path d="M2 20h20M9.5 20l.4-4M14.5 20l-.4-4" />
  </svg>
);

const AppleGlyph = () => (
  <svg viewBox="0 0 24 24">
    <path d="M16.5 1.6c.1 1-.3 2-.9 2.8-.7.8-1.7 1.4-2.7 1.3-.1-1 .4-2 1-2.7.6-.8 1.7-1.3 2.6-1.4zM19.6 17c-.5 1.2-.8 1.7-1.4 2.7-.9 1.4-2.2 3.2-3.8 3.2-1.4 0-1.8-.9-3.7-.9s-2.4.9-3.7.9c-1.6 0-2.8-1.6-3.7-3C.8 16.6.5 11.4 2.6 8.6c1-1.4 2.5-2.2 4-2.2 1.5 0 2.5 1 3.8 1 1.2 0 2-1 3.8-1 1.3 0 2.7.7 3.7 2-3.3 1.8-2.7 6.4 1.7 8.6z" />
  </svg>
);

// Download page — MindFeed for macOS.
export const Section40 = () => {
  const t = useTranslations();
  return (
    <PlatformRow
      id="macos"
      label={t('pages.download.macos.label')}
      icon={<MacGlyph />}
      tag={t('pages.download.macos.tag')}
      title={t('pages.download.macos.title')}
      description={t('pages.download.macos.description')}
      features={[
        t('pages.download.macos.feature1'),
        t('pages.download.macos.feature2'),
        t('pages.download.macos.feature3'),
      ]}
      actions={
        <StoreBadge
          icon={<AppleGlyph />}
          small={t('pages.download.macos.storeSmall')}
          big="macOS"
          href={marketing.macAppStoreUri}
          newTab
        />
      }
      visual={
        <Image
          src={imgWebapp}
          alt={t('pages.download.macos.imageAlt')}
          width={1440}
          height={900}
          className={styles.shot}
          sizes="(max-width: 1024px) 100vw, 620px"
        />
      }
    />
  );
};

const styles = {
  shot: [
    'relative z-[2] h-auto w-full rounded-[14px] border',
    'border-[#F0F0F0] shadow-[0_20px_50px_rgba(20,30,60,0.08)]',
    'marketing-dark:border-white/10',
    'marketing-dark:shadow-[0_50px_110px_rgba(2,8,30,0.66),0_8px_24px_rgba(0,0,0,0.34)]',
  ].join(' '),
};
